<template>
  <v-dialog :value="isPopup" max-width="800" persistent>
    <v-card>
      <v-card-title class="text-sm-left font-weight-bold px-5">
        Tìm điểm trường
<!--        <v-divider style="border-color: #d2d2d2" class="mt-5 mb-3"></v-divider>-->
        <v-spacer />
        <v-icon class="mt-3" aria-label="Close" @click="$emit('closePopup', false)">mdi-close</v-icon>
      </v-card-title>
      <v-card-text class="mt-2 school-search-popup">
<!--      left-->
        <div class="school-search-popup__left">
        <validation-observer v-slot="{}" ref="validInfo">
            <validation-provider v-slot="{ errors }" name="Tỉnh/TP" rules="required">
              <v-autocomplete
                  v-model="infoSchool.province"
                  :items="provinces"
                  item-text="ten"
                  item-value="id"
                  label="Tỉnh/TP *"
                  @change="onChangeProvince"
                  :error-messages="errors"
              />
            </validation-provider>
           <validation-provider v-slot="{ errors }" name="Quận/Huyện" rules="required">
              <v-autocomplete
                  v-model="infoSchool.district"
                  :items="districts"
                  item-text="ten"
                  item-value="id"
                  label="Quận/Huyện *"
                  @change="onChangeDistrict"
                  :error-messages="errors"
              />
           </validation-provider>
          <validation-provider v-slot="{ errors }" name="Phường/Xã *" rules="required">
            <v-autocomplete
                v-model="infoSchool.ward"
                label="Phường/Xã *"
                :items="wards"
                item-text="ten"
                item-value="id"
                :error-messages="errors"
            />
          </validation-provider>
          <validation-provider v-slot="{ errors }" rules="max:255" name="Địa chỉ chi tiết">
            <v-text-field
                v-model="infoSchool.detailAddress"
                label="Địa chỉ chi tiết"
                :error-messages="errors"
            />
          </validation-provider>
        </validation-observer>
      </div>
<!--        right-->
      <div class="school-search-popup__right">
        <div class="school-search-popup__block" v-for="(school,index) in listSchool" :key="index">
            <div class="d-flex align-center school-search-popup__block__title">
              <h3>{{ school.school_name }}</h3>
              <div class="pl-2">
                <v-btn
                    class=""
                    width="24"
                    height="24"
                    icon
                    @click="changeValueCheck(school)"
                    style="color: #fff"
                >
                  <v-icon
                      class=""
                      :color="school.isCheck ? '#239944' : ''"

                      style="font-size: 24px"
                  >{{
                      school.isCheck ? "mdi-checkbox-marked" : "mdi-checkbox-blank-outline"
                    }}
                  </v-icon>
                </v-btn>
              </div>
            </div>
            <div class="school-search-popup__block__content">
              <v-icon style="margin-right:10px;padding-top: 3px;" color="red">mdi-map-marker</v-icon>
              <div>
                <span v-if="school.address">{{ school.address+', '  }}</span>
                <span v-if="school.ward">{{ school.ward+', '  }}</span>
                <span v-if="school.district">{{ school.district+', '  }}</span>
                <span v-if="school.province">{{ school.province  }}</span>
              </div>
            </div>
          </div>
      </div>
      </v-card-text>
      <div class="d-flex mr-2" style="justify-content: end">
        <v-btn color="primary" class="my-4 school-search-popup__button" @click.prevent="updateContactSchool">
            Update
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import RepositoryFactory from '@/repositories/RepositoryFactory';
import { moduleSchoolLevel } from '@/helpers/constants';
const AddressRepository = RepositoryFactory.get('address');
const SchoolRepository = RepositoryFactory.get('school');
export default {
  name: "SchoolSearchPopup",
  props: {
    isPopup: {
      type: Boolean,
      default: false
    },
    infoContact: {
      type: Object,
    }
  },
  data() {
    return {
      moduleSchoolLevel,
      provinces: [],
      districts: [],
      wards: [],
      infoSchool: {
        province:'',
        district: '',
        ward: '',
        detailAddress: '',
      },
      listSchool: [],
      selectedSchool: [],
      attrs: [
        'id',
        'school_name',
        'school_code',
        'district',
        'province',
        'ward',
        'district_id',
        'province_id',
        'ward_id',
        'address',
        'type'
      ]
    }
  },
  computed: {
    moduleschoolLevelId() {
      return this.$store.state.module.schoolLevelId
    }
  },
  async created() {
    await this.getProvinces()
    await this.getListSchool()
    if(this.infoContact) {
      this.infoSchool.province = this.infoContact.tinhId === 0 ? '' : this.infoContact.tinhId
      this.infoSchool.district =  this.infoContact.huyenId === 0 ? '' : this.infoContact.huyenId
      this.infoSchool.ward = this.infoContact.xaId === 0 ? '' : this.infoContact.xaId
      this.infoSchool.detailAddress = this.infoContact.detailAddress
      this.selectedSchool = this.infoContact.schoolIds.length > 0 ? this.infoContact.schoolIds : []
      if(this.selectedSchool && this.listSchool.length > 0) {
        this.listSchool.forEach(school => {
          if(this.selectedSchool.includes(school.id)) {
            school.isCheck = true
          }
        })
      }
    }
    if (this.infoSchool.province) {
      await this.getDistricts()
    }
    if (this.infoSchool.district) {
      await this.getWards()
    }
  },
  methods: {
    attrsDataUrl(dataRequest) {
      let data = "";
      dataRequest.forEach((item) => {
        data += "&attrs[]=" + item;
      });
      return data;
    },
    changeValueCheck(school) {
      if(school.isCheck) {
        const index = this.selectedSchool.findIndex(item => item.id === school.id)
        this.selectedSchool.splice(index,1)
        school.isCheck = false
      }else {
        this.selectedSchool.push(school.id)
        school.isCheck = true
      }
      // this.listSchool.forEach((item) => {
      //   item.isCheck = item === school;
      // });
      // this.selectedSchool = school.isCheck ? school.id : null
    },
    onChangeProvince() {
      this.infoSchool.district = ''
      this.infoSchool.ward = ''
      this.districts = []
      this.wards = []
      this.getDistricts()
      if (this.infoSchool.province == 0) {
        this.infoSchool.district = 0
        this.infoSchool.ward = 0
      }
    },
    onChangeDistrict() {
      if (this.infoSchool.district) {
        this.infoSchool.ward = ''
        this.wards = []
        this.getWards()
      }
    },
    async getProvinces() {
      const loading = this.$loading.show()
      const respond = await AddressRepository.provinces({ limit: 100 });
      if (_.get(respond, 'success', false)) {
        this.provinces = _.get(respond, 'data', []).filter(
            data => data.id != 0
        )
        loading.hide()
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(respond, 'message', '')
        });
        loading.hide()
      }
    },
    async getDistricts() {
      const respond = await AddressRepository.districts({ limit: 100 }, this.infoSchool.province);
      if (_.get(respond, 'success', false)) {
        this.districts = _.get(respond, 'data', []);
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(respond, 'message', '')
        });
      }
    },
    async getWards() {
      const respond = await AddressRepository.wards(
          { limit: 100 },
          this.infoSchool.province,
          this.infoSchool.district
      );
      if (_.get(respond, 'success', false)) {
        this.wards = _.get(respond, 'data', []);
        if (this.wards.length === 0) {
          this.infoSchool.ward = 0;
        }
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(respond, 'message', '')
        });
      }
    },
   async getListSchool() {
      const loading = this.$loading.show()
       const filter = { limit: 1000 , 'filters[$eq__status]': 1 }
      if([this.moduleSchoolLevel.STATION,this.moduleSchoolLevel.SCHOOL].includes(this.moduleschoolLevelId)) {
        filter[`filters[$eq__type]`] = this.moduleschoolLevelId === this.moduleSchoolLevel.STATION ? 'station' : 'school'
      }
      const respond = await SchoolRepository.listSchoolApi(this.attrsDataUrl(this.attrs),filter);
      if (_.get(respond, 'success', false)) {
        this.listSchool = _.get(respond, 'data', []).map( item => {
          return {
            ...item,
            isCheck: false
          }
        })
        loading.hide()
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(respond, 'message', '')
        });
        loading.hide()
      }
    },
   async updateContactSchool() {
      const valid = await this.$refs.validInfo.validate()
      if(valid) {
          const data = {
            "tinhId": this.infoSchool.province,
            "huyenId": this.infoSchool.district,
            "xaId": this.infoSchool.ward,
            "detailAddress": this.infoSchool.detailAddress,
            "schoolIds": this.selectedSchool ? this.selectedSchool : []
          }
          try{
            const response = await SchoolRepository.updateContactSchoolApi(this.infoContact.id , data)
            if(response.success) {
              this.$swal({
                type: "success",
                icon: "success",
                text: "Cập nhật thông tin thành công!",
                timer: 3000,
              })
            }else {

            }
          }catch (e) {
            console.log(e)
          }
      }else {
        this.$swal({
          type: "error",
          icon: "error",
          text: "Vui lòng nhập đầy đủ thông tin!",
          timer: 3000,
        });
        return;
      }
    }

  }
}
</script>
<style lang="scss">
.school-search-popup{
  display: flex;
  column-gap: 20px;
  &__left{
    width: 30%;
    display: grid;
    .v-label{
      font-weight: 400 !important;
    }
  }
  &__right {
    width: calc(100% - 30% - 20px);
    background: #FAFAFF;
    box-shadow: inset 0 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 8px;
    padding:22px 20px;
    overflow-y: auto;
    height: 400px;
  }
  &__block {
    border-radius: 15px;
    margin-bottom: 20px;
    h3 {
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 700;
      font-size: 17px !important;
      line-height: 30px;
      color: #FFF !important;
    }
    &__title {
      justify-content: space-between;
      column-gap: 20px;
      background: #FF8730;
      border-radius: 15px 15px 0px 0px;
      padding:5px 15px 5px 23px;
    }
    &__content {
      padding:22px 23px;
      background: #F9F9F9;
      box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
      border-radius: 0 0 20px 20px;
      display: flex;
      align-items: start;
      .v-icon.v-icon {
        font-size: 24px !important;
      }
      div {
        font-weight: 400;
        font-size: 17px;
        line-height: 30px;
        color: #222222;
        font-style: italic;
      }
    }
  }
  &__button{
    background: linear-gradient(90deg, #1A951F 0%, #2BA120 100%) !important;
    border-radius: 25px !important;
    text-transform: capitalize !important;
    font-size: 15px !important;
  }
}
</style>